<template>
    <div
        class="loader"
        ref="loader"
        :style="{'z-index': messageType === 'offline' ? 20 : 12}"
    >
        <div
            class="loader-message"
            :class="{
                'openedSidebar' : isOpenedSidebar,
                'wideScreen': !$vuetify.breakpoint.xsOnly
            }"
        >
            <div
                ref="animated-text"
                class="text"
            >
                <span
                    v-if="(messageType in animation) && animatedText"
                    class="h1"
                >
                    {{ $t(animatedText) }}
                </span>
                <span
                    v-else-if="messageType != null"
                    class="h2"
                >
                    {{ $t('loading.' + messageType) }}
                </span>
            </div>

            <span class="animated-dot">.</span>
            <span class="animated-dot">.</span>
            <span class="animated-dot">.</span>
        </div>
        <div class="loader-background">
            <div
                class="loader-background-image"
                :style="{ backgroundImage: 'url('+ loadingBackground +')'}"
            />
            <div class="loader-background-white-overlay"/>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'Loader',
        props: {
            'messageType': {
                type: String,
                required: true
            },
            'isOpenedSidebar': {
                type: Boolean,
                required: false
            }
        },
        computed: {
            ...mapGetters([
                'loadingBackground'
            ])
        },
        data() {
            return {
                animatedText : null,
                animation: {
                    'loading-cutaway-view' : {
                        text : [
                            'loading.3d-image',
                            'loading.plot-availability',
                            'loading.filters'
                        ],
                        interval: 5000
                    },
                    'loading-variation': {
                        text: [
                            'loading.3d-image',
                        ],
                        interval: 5000
                    }
                }
            }
        },
        mounted() {
            this.startAnimation(this.$props.messageType);
        },
        methods: {
            startAnimation(type) {
                if (this.animation[type]) {
                    let currentAnimation = JSON.parse(JSON.stringify(this.animation[type]));
                    this.animatedText = currentAnimation.text.shift();
                    let timer = window.setInterval(() => {
                        if (currentAnimation.text.length)
                            this.animatedText = currentAnimation.text.shift();
                        else
                            clearInterval(timer);
                    }, this.animation[type].interval);
                }
            }
        },
        watch: {
            messageType() {
                if (this.messageType in this.animation)
                    this.startAnimation(this.messageType)
            }
        }
    }
</script>

<style lang="scss">
    @import "@/assets/scss/components/_loader.scss";
</style>


// WEBPACK FOOTER //
// src/components/Loader.vue